export enum CallMethodEnums {
  DELETE = 'DELETE',
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH'
}

export type CallArgs<T, U> = {
  body?: T;
  formData?: FormData;
  headers?: Record<string, string>;
  params?: Record<string, unknown>;
  isProtected: boolean;
  method: CallMethodEnums;
  resHandler?: ( res: APIRes<U> ) => void;
  route: string;
  signal?: AbortSignal;
};

export type APIRes<T = object> = {
  type: 'success' | 'error',
  message: string;
  data: T;
};
